import React from 'react';
import {MdTextField, MdCheckbox} from 'core/components/fields/fields';
import {FieldText, FormProps, ClosedContentProps, lovLabel, lovValue} from 'core/form/formUtils';
import ActiveItem from 'core/components/blockComp/activeItem';
import {Validate} from 'core/form/validate';
import {observer} from "mobx-react";
import {createForm} from 'core/form/createForm';
import {grey400} from "material-ui/styles/colors";
import styled from "styled-components";
import {Contract, CONTRACTTYPE, CONTRACTTYPE_MAP} from "core/document/documentDomain";
import {FIELDDEFDISPLAYTYPE} from "core/form/form";
import RadioButtonField from "core/components/fields/radioButtonField";
import StyledSelect from "core/components/fields/styledSelect";
import StyledDatePicker from "core/components/fields/styledDatePicker";
import Avatar from "material-ui/Avatar";
import {acronym} from "core/common/utils/stringUtils";
import {PARTYROLE} from "party/partyDomain";
import {optionsSearch} from "core/common/service/commonDataService";
import {IsRequired} from "core/form/rules";



const FlexRowDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const FlexDiv = styled.div`
  display: flex;
  flex-direction: column;
`;

const HeaderWrapper = styled.div`
  display: flex;
  margin-top: 12px;
  margin-bottom: 5px;
  align-items: center;
`;

const Header = styled.div` 
  color: ${grey400};
  margin-right: 10px;
  font-size: 20px;
`;


const AvatarStyle = {
  margin: "0 15px 0 0"
};

export const ContractDetailComp = ({dataObject, entity, entities, fields, disabled, standAlone}: ClosedContentProps<Contract> & {standAlone?: boolean}) => {

  return (
    <FlexRowDiv>
      <Avatar backgroundColor={CONTRACTTYPE_MAP[lovValue(dataObject.contractType)].backgroundColor} style={AvatarStyle}>
        {acronym(lovLabel(dataObject.contractType), 1)}
      </Avatar>
      <FlexDiv>

        <HeaderWrapper>
          <Header>
            <span className="zz-mr-5">{dataObject.contractNumber}</span> - { " " + lovLabel(dataObject.contractStatus)}
          </Header>

          {(!standAlone && dataObject.customer) ? (
            <FieldText value={dataObject.customer.label} linkProps={{to:'partyDetail', params:{id: dataObject.customer.value} }} />
          ) : null}

        </HeaderWrapper>


        <div className="form-text-row">
          <FieldText label={fields.sendForSigningDate.textLabel} value={dataObject.sendForSigningDate}
                     mdField={fields.sendForSigningDate.mdField}/>
          <FieldText label={fields.signingDate.textLabel} value={dataObject.signingDate}
                     mdField={fields.signingDate.mdField}/>
        </div>
        <div className="form-text-row">
          <FieldText value={dataObject.comment}/>
        </div>

      </FlexDiv>
    </FlexRowDiv>
  )
};

@createForm({
  formName: 'ContractForm',
  fields: [{
    name: 'contractNumber'
  }, {
    name: 'contractStatus',
    validators: ['IsRequired']
  }, {
    name: 'contractType',
    displayType: FIELDDEFDISPLAYTYPE.radioButton,
    validators: ['IsRequired']
  }, {
    name: "sendForSigningDate"
  }, {
    name: "signingDate"
  },{
    name: "customer"
  }, {
    name: "comment",
    displayType: FIELDDEFDISPLAYTYPE.textArea
  }]
}, ContractDetailComp)
@observer
export default class ContractForm extends React.Component<FormProps<Contract, Contract>, undefined> {



  render() {

    let {dataObject, rootObject, entities, entity, formName} = this.props;
    let fields = dataObject.getFormFields(formName);
    let {contractNumber, contractStatus, contractType, sendForSigningDate, signingDate, comment, customer}= fields;

    let openContent = (
      <div>

        <div className="row">
          <div className="col-xs-12">
            <div style={{color: grey400, marginBottom: 5}}>{contractType.mdField.formLabelActive}</div>
            <RadioButtonField {...contractType.props} groupStyle={{display: 'flex'}}
                              optionStyle={{width: 'initial', marginRight: 15}} labelStyle={{whiteSpace: 'nowrap', marginLeft: -10}}/>
            <Validate field={contractType} value={contractType.props.value} />
          </div>
        </div>

        <div className="row">
          <div className="fx col-xs-12 col-sm-6">
            <StyledSelect  {...customer.props} async={true} loadOptions={optionsSearch.bind(this, 'Party', {role: [PARTYROLE.CUSTOMER_ROLE, PARTYROLE.OWNER_ROLE]})} clearable={true} />
            <Validate field={customer} value={customer.props.value}/>
          </div>

          <div className="xs col-xs-12 col-sm-6">
            <MdTextField {...contractNumber.props} />
            <Validate field={contractNumber} value={contractNumber.props.value}/>
          </div>
        </div>

        <div className="row">
          <div className="fx col-xs-12 col-sm-6">
            <StyledSelect {...contractStatus.props} />
            <Validate field={contractStatus} value={contractStatus.props.value}/>
          </div>
          <div className="fx col-xs-12 col-sm-3">
            <StyledDatePicker {...sendForSigningDate.props} />
          </div>
          <div className="fx col-xs-12 col-sm-3">
            <StyledDatePicker {...signingDate.props} />
          </div>
        </div>

        <div className="row">
          <div className="xs col-xs-12">
            <MdTextField {...comment.props} multiLine={true} rows={3}/>
          </div>
        </div>


      </div>
    );

    return (
        <ActiveItem openContent={openContent} closedContent={<ContractDetailComp {...{dataObject, entity, entities, fields}} standAlone={false} />} {...this.props} validate={this.props.validate} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/core/document/component/contractForm.tsx